module.exports = __webpack_public_path__ + "static/matiaswork1-b97d40fda69fc8ea1114dc52e77ed5a8.jpg";